export const formatTooltipContent = (content) => {
  if (typeof content === 'string') {
    return content.trim();
  }
  return content;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Tooltip/utils/tooltipHelpers.js